import { IWindowService } from 'angular';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

/* @ngInject */
export default class MobileConnectCallbackController {
  constructor(
    private $window: IWindowService,
    private $stateParams,
    private globalSpinner: GlobalSpinnerService
  ) {}

  public $onInit() {
    this.globalSpinner.start();
    const { state, code, error } = this.$stateParams;
    this.mobileConnectResult({
      code,
      error,
      state
    });
  }

  public mobileConnectResult(states: any) {
    this.$window.parent.postMessage(
      {
        mobileConnect: states
      },
      '*'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/mobile-connect-callback/mobile-connect-callback.controller.ts